var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-content-container',[(_vm.videoController.file)?_c('VideoViewer'):_c('p-content-placeholder',{attrs:{"image":require('../background_empty.svg')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }